var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2736 1617",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1427.15,-2107.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7",
    transform: "matrix(-1.10273,0,0,0.460853,4162.27,2107.53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23982,0,0,1.17503,-126.515,-242.601)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.765695,0,0,29.9294,2236.71,-106916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1040.54,
    y: 3587.21,
    width: 1683.67,
    height: 72.917,
    style: {
      fill: "white"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1040.54,
    y: 3587.21,
    width: 1683.67,
    height: 72.917
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18023,0,0,0.076233,-3305.6,3405.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3665.12,3233.75L3642.84,3103.44L3767.16,2929.33L3843.63,2986.63L3903.01,3091.67C3903.01,3091.67 4006.26,3185.3 3953.99,3241.41C3896.5,3303.12 3876.87,3324.95 3876.87,3324.95L3681.16,3327.57L3681.16,3327.53L3697.75,3327.35L3666.13,3291.29L3625.81,3265.3L3669.09,3203.3L3671.59,3184.13L3665.12,3233.75Z",
    style: {
      fill: "rgb(229,230,232)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.31858,0,0,3.28186,9483.03,-6425.08)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6579.59,
    cy: 2429.92,
    r: 196.812,
    style: {
      fill: "rgb(229,230,232)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6579.59,
    cy: 2429.92,
    r: 196.812
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-15.2683,-6.91439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6842.46,2159.99L6585.82,2159.99L6585.82,2447.28L6752.07,2859.81L6842.46,2159.99Z",
    style: {
      fill: "rgb(255,226,112)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-271.988,-6.91439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6842.46,2159.99L6585.82,2159.99L6585.82,2298.57L6842.46,2447.28L6842.46,2159.99Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.819727,0,0,1.22063,2338.42,-1812.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1040.54,
    y: 3587.21,
    width: 1683.67,
    height: 72.917,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.819727,0,0,1.22063,2338.42,-3953.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1040.54,
    y: 3587.21,
    width: 1683.67,
    height: 72.917,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.871813,0,0,2.16989,2480.31,-7336.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1802.46,3911.77L1705.11,3814.43L1289.04,3814.43",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "3.52px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.871813,0,0,2.16989,-885.439,-6216.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1802.46,3721.67L1705.11,3814.43L1289.04,3814.43",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "3.52px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.871813,0,0,2.16989,2480.31,-7336.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1296.56,
    y: 3755.25,
    width: 296.17,
    height: 33.806,
    style: {
      fill: "rgb(229,230,232)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.871813,0,0,2.16989,1645.18,-6217.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1296.56,
    y: 3755.25,
    width: 296.17,
    height: 33.806,
    style: {
      fill: "rgb(229,230,232)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.939866,1.35058,0.588108,2.53531,-551.323,-11130.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1489.28,4643.86L1462.08,4643.86L1462.08,4873.96L1489.28,4859.51L1489.28,4643.86Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939866,1.35058,-0.588108,2.53531,2142.92,-11130.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1489.28,4643.86L1462.08,4643.86L1462.08,4873.96L1489.28,4859.51L1489.28,4643.86Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.626046,0,0,1.23553,986.839,-287.706)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-326.047,-1217.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 878.824,1118.57 800.096,1139.3C761.808,1149.38 728.411,1172.87 705.978,1205.5C654.291,1280.66 563.216,1413.12 563.216,1413.12L781.52,1567.96L824.373,1504.29C824.373,1504.29 888.09,1706.17 888.555,1762.93C889.02,1819.69 868.453,1980.87 868.453,1980.87L1346.04,1980.87C1346.04,1980.87 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1335.67,1633.55 1335.67,1633.55C1335.67,1633.55 1359.14,1631.64 1386.12,1629.44C1432.41,1625.67 1469.81,1590.14 1475.96,1544.11C1484.57,1479.69 1496.97,1386.89 1507.38,1309C1518.49,1225.79 1465.49,1147.46 1384.12,1126.85C1298.5,1105.15 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 878.824,1118.57 800.096,1139.3C761.808,1149.38 728.411,1172.87 705.978,1205.5C654.291,1280.66 563.216,1413.12 563.216,1413.12L781.52,1567.96L824.373,1504.29C824.373,1504.29 888.09,1706.17 888.555,1762.93C889.02,1819.69 868.453,1980.87 868.453,1980.87L1346.04,1980.87C1346.04,1980.87 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1335.67,1633.55 1335.67,1633.55C1335.67,1633.55 1359.14,1631.64 1386.12,1629.44C1432.41,1625.67 1469.81,1590.14 1475.96,1544.11C1484.57,1479.69 1496.97,1386.89 1507.38,1309C1518.49,1225.79 1465.49,1147.46 1384.12,1126.85C1298.5,1105.15 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1017.21,607.926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1847.9,1000.16L1568.93,873.462C1568.93,873.462 1634.07,864.769 1703.35,873.2C1781.76,882.742 1877.57,827.557 1877.57,827.557C1877.57,827.557 1893.73,847.722 1912.4,871.035C1946.87,914.065 2002.07,934.87 2056.37,925.3C2147.86,909.175 2277.81,886.272 2277.81,886.272L2345.87,989.265L2406.5,1310.88C2406.5,1310.88 2276.7,1149.93 2228.36,1114.81C2161.24,1066.05 2104.91,1078.67 2066.65,1097.6C1979.05,1140.94 1867.78,1321.4 1867.78,1321.4L1847.9,1000.16ZM2209.42,537.3C2209.42,537.3 2265.86,557.286 2311.83,573.565C2344.69,585.203 2363.05,620.177 2353.98,653.839C2340.74,702.982 2324.12,764.627 2324.12,764.627L2345.99,989.418L2354.82,1037.3L2485.77,1036.81C2485.77,1036.81 2532.26,886.084 2536.22,877.923C2571.02,806.131 2537.52,613.508 2548.19,601.9C2548.19,601.9 2470.06,524.823 2470.06,524.823L2160.12,421.228L2209.42,537.3Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51.4616,-5.85918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,2924.11,93.2916)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120.52,1046.06C1120.52,1046.06 1122.47,1046.14 1125.47,1046.25C1143.51,1046.94 1157.77,1061.77 1157.77,1079.82L1157.77,1271.53L1384.15,1066.07L1150.1,964.475L1120.52,1046.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1013.06,1099.1 1027.62,1068.09C1035.53,1051.26 1052.46,1040.53 1071.05,1040.55C1084.83,1040.57 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78314,0.185352,0.152875,2.16196,3101.34,-1539.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-742.346,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.04,1074.4 1082.43,1035.85C1063.26,1027.01 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,46.074,-111.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.996725,-0.0808635,-0.0808635,0.996725,2320.61,90.5101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999523,0.0308927,-0.0308927,0.999523,27.0585,-32.5891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-731.005,-1319.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.75,875.368 1161.19,879.642L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.16989,3302.68,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.563C1161.6,875.563 1177.8,868.956 1191.32,882.086C1191.32,882.086 1181.91,875.309 1161.36,879.583L1161.6,875.563Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-894.318,-1319.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-726.088,-1319.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.09,977.305C1085.09,977.305 1106.57,984.859 1139.47,983.004L1138.77,999.097C1138.77,999.097 1102.36,1003.48 1085.09,977.305Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.76816,0.335527,0.276737,2.14379,4606.55,-1963.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0444",
    d: "M1610.4,1547.41C1570.81,1590.02 1568.66,1655.29 1605.38,1700.4C1605.38,1700.4 1605.38,1700.4 1605.38,1700.4C1622.93,1721.97 1650.11,1733.32 1677.78,1730.64C1705.45,1727.97 1729.95,1711.63 1743.05,1687.11C1816.83,1549.01 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1890.81,1245.71C1890.81,1245.71 1712.25,1437.83 1610.4,1547.41Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u04441",
    d: "M1610.4,1547.41C1570.81,1590.02 1568.66,1655.29 1605.38,1700.4C1605.38,1700.4 1605.38,1700.4 1605.38,1700.4C1622.93,1721.97 1650.11,1733.32 1677.78,1730.64C1705.45,1727.97 1729.95,1711.63 1743.05,1687.11C1816.83,1549.01 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1890.81,1245.71C1890.81,1245.71 1712.25,1437.83 1610.4,1547.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2249.34,995.436C2249.34,995.436 2249.34,995.436 2249.34,995.436C2289.22,1012.23 2335.35,1002 2364.4,969.93C2393.44,937.861 2399.07,890.945 2378.43,852.919C2287.61,685.617 2185.6,497.703 2185.6,497.703L2003.37,575.284L2249.34,995.436Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,101.132,-152.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.977656,0.210211,0.23343,-1.08564,-259.646,2101.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.59,1189.77 2043.49,1173.69C2043.63,1171.11 2044.92,1168.69 2047.06,1166.97C2049.19,1165.25 2052.01,1164.37 2054.87,1164.52C2056.08,1164.59 2057.31,1164.66 2058.51,1164.72C2064.06,1165.03 2068.43,1169.09 2068.59,1174.1C2068.96,1185.43 2069.59,1205.03 2069.97,1216.88C2070.05,1219.24 2068.89,1221.49 2066.85,1222.96C2064.81,1224.43 2062.12,1224.95 2059.58,1224.36C2051.18,1222.43 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971079,0.238758,0.265129,-1.07834,-301.21,2005.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.59,1189.77 2043.49,1173.69C2043.63,1171.11 2044.92,1168.69 2047.06,1166.97C2049.19,1165.25 2052.01,1164.37 2054.87,1164.52C2056.08,1164.59 2057.31,1164.66 2058.51,1164.72C2064.06,1165.03 2068.43,1169.09 2068.59,1174.1C2068.96,1185.43 2069.59,1205.03 2069.97,1216.88C2070.05,1219.24 2068.89,1221.49 2066.85,1222.96C2064.81,1224.43 2062.12,1224.95 2059.58,1224.36C2051.18,1222.43 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.69,1194.65 2042.19,1178.81C2042.29,1175.6 2043.59,1172.59 2045.78,1170.49C2047.98,1168.38 2050.87,1167.38 2053.76,1167.72C2055.61,1167.93 2057.51,1168.16 2059.29,1168.36C2064.47,1168.97 2068.46,1173.67 2068.66,1179.41C2069.22,1195.86 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817077,-0.576529,-0.576529,0.817077,4382.05,1386.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2048.21,1179.03C2048.21,1179.03 2033.12,1151.88 2024.14,1135.71C2022.47,1132.7 2022.15,1129.14 2023.26,1125.89C2024.36,1122.64 2026.79,1120.01 2029.94,1118.64C2029.94,1118.64 2029.94,1118.64 2029.95,1118.64C2036.19,1115.95 2043.47,1118.36 2046.88,1124.25C2057.53,1142.7 2078.73,1179.4 2078.73,1179.4L2048.21,1179.03Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3993.3,2629.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.601081,-0.799188,0.887462,-0.667472,2230.44,3642.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.59,1189.77 2043.49,1173.69C2043.63,1171.11 2044.92,1168.69 2047.06,1166.97C2049.19,1165.25 2052.01,1164.37 2054.87,1164.52C2056.08,1164.59 2057.31,1164.66 2058.51,1164.72C2064.06,1165.03 2068.43,1169.09 2068.59,1174.1C2068.96,1185.43 2069.59,1205.03 2069.97,1216.88C2070.05,1219.24 2068.89,1221.49 2066.85,1222.96C2064.81,1224.43 2062.12,1224.95 2059.58,1224.36C2051.18,1222.43 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2040.68,1194.65 2040.54,1178.15C2040.51,1174.54 2041.95,1171.07 2044.53,1168.55C2047.11,1166.03 2050.61,1164.67 2054.22,1164.8C2054.78,1164.81 2055.35,1164.83 2055.91,1164.85C2062.88,1165.08 2068.48,1170.68 2068.7,1177.66C2069.1,1189.77 2069.68,1207.88 2070.02,1218.41C2070.2,1223.98 2069.33,1229.53 2067.46,1234.77C2061.7,1250.84 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.525657,-0.850697,-0.850697,0.525657,4103.91,2314.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.46,1198.21 2040.07,1180.41C2039.89,1172.39 2046.25,1165.74 2054.27,1165.57C2054.27,1165.57 2054.27,1165.57 2054.27,1165.57C2062.16,1165.39 2068.74,1171.58 2069.05,1179.47C2069.81,1198.78 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788L2075.66,421.558C2073.31,420.364 2070.36,419.725 2068.33,419.893L2058.58,413.585L2084.95,398.971C2084.95,398.971 2113.2,417.017 2133.82,430.189C2147.27,438.779 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788L2075.66,421.558C2073.31,420.364 2070.36,419.725 2068.33,419.893L2058.58,413.585L2084.95,398.971C2084.95,398.971 2113.2,417.017 2133.82,430.189C2147.27,438.779 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2074.89,417.109C2074.89,417.109 2113.49,442.598 2108.6,445.733L2066.22,422.191L2060.12,419.893C2060.12,419.893 2060.57,419.555 2061.23,419.067C2064.26,416.826 2068.07,415.923 2071.78,416.568C2073.48,416.864 2074.89,417.109 2074.89,417.109Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.05283,0,0,0.950529,-2569.23,-23.0029)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0211275,2.16925,-0.871557,0.0525849,3084.63,-1046.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1362.91,1735.25C1362.91,1735.25 1447.02,1790.31 1499.51,1824.66C1523.69,1840.49 1556.04,1838.74 1578.09,1820.43C1671.94,1742.49 1909.51,1545.2 1909.51,1545.2L1898.11,1454.79L1823.27,1508.53L1568.14,1646.34L1496.87,1564.34L1362.91,1735.25Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1362.91,1735.25C1362.91,1735.25 1447.02,1790.31 1499.51,1824.66C1523.69,1840.49 1556.04,1838.74 1578.09,1820.43C1671.94,1742.49 1909.51,1545.2 1909.51,1545.2L1898.11,1454.79L1823.27,1508.53L1568.14,1646.34L1496.87,1564.34L1362.91,1735.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1836.6,-506.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1485.7,1620.49C1485.7,1620.49 1590.23,1512.36 1696.12,1581.74L1679.23,1436.85L1568.11,1397.06L1458.14,1421.31L1084.89,1508.96L1170.38,1645.51L1485.7,1620.49Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.608942,1.55284,-0.623897,1.51562,1425.3,-1858.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.237404,-0.505817,0.417188,0.195806,574.967,1122.34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0202657,1.98737,-1.63915,0.024571,2901.7,-1082.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1894.61,1301.89C1894.61,1301.89 1892.21,1288.54 1890.26,1277.63C1888.6,1268.41 1888.64,1259.05 1890.38,1249.95C1893.69,1232.58 1898.95,1204.91 1898.95,1204.91L1935.62,1223.9L1941.13,1277.36L1894.61,1301.89Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32858,-1.16426,-0.960257,-1.61083,-430.988,6946.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1931.79,1186.05 1947.52,1177.09C1952.25,1174.39 1958.42,1175.36 1962.37,1179.42C1962.73,1179.8 1963.1,1180.17 1963.47,1180.55C1968.12,1185.33 1968.16,1192.73 1963.55,1197.12C1952.79,1207.4 1935.39,1224 1935.39,1224L1898.62,1204.95Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,101.132,-152.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.560954,-0.827847,-0.919286,0.622914,4304.03,2159.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.97,1214.61C2040.97,1214.61 2042.57,1188.15 2043.46,1173.46C2043.78,1168.17 2048.97,1164.2 2055.12,1164.54C2056.03,1164.59 2056.94,1164.64 2057.85,1164.69C2063.74,1165.01 2068.47,1169.2 2068.68,1174.29C2069.28,1188.88 2070.4,1216.02 2070.4,1216.02L2040.97,1214.61Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.400184,-0.916435,-1.01766,0.444386,4074.61,2531.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.91,1211.14C2041.91,1211.14 2042.98,1187.31 2043.6,1173.51C2043.84,1168.19 2048.93,1164.2 2055.04,1164.53C2055.9,1164.58 2056.77,1164.63 2057.62,1164.67C2063.6,1165.01 2068.42,1169.37 2068.56,1174.59C2068.93,1188.36 2069.59,1212.52 2069.59,1212.52L2041.91,1211.14Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.7,1194.43 2042.19,1178.6C2042.29,1175.43 2043.62,1172.47 2045.88,1170.42C2048.13,1168.37 2051.1,1167.41 2054.1,1167.76C2055.61,1167.93 2057.15,1168.11 2058.62,1168.29C2064.15,1168.93 2068.46,1173.82 2068.66,1179.68C2069.24,1196.19 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.513049,-0.858359,-0.858359,0.513049,4060.69,2322.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.42,1174.12C2046.42,1174.12 2034.68,1153.05 2027.4,1139.99C2025.91,1137.31 2025.58,1134.2 2026.5,1131.35C2027.41,1128.5 2029.48,1126.14 2032.26,1124.8C2032.26,1124.8 2032.26,1124.8 2032.26,1124.8C2037.57,1122.25 2044.15,1124.26 2047.09,1129.34C2054.87,1142.75 2068.47,1166.21 2068.47,1166.21L2066.49,1167.26L2046.42,1174.12Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3993.3,2629.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.975784,0.218737,-0.242898,1.08356,360.508,-575.194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.78,1213.22C2040.78,1213.22 2043.13,1192.9 2044.61,1180.15C2045.26,1174.51 2050.97,1170.36 2057.58,1170.73C2057.58,1170.73 2057.58,1170.73 2057.58,1170.73C2064.52,1171.11 2069.92,1176.15 2069.77,1182.11C2069.39,1197.24 2068.73,1223.09 2068.73,1223.09L2040.78,1213.22Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997418,0.0718087,-0.0718087,0.997418,106.167,-134.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2040.68,1194.33 2040.53,1177.84C2040.5,1174.28 2041.96,1170.89 2044.59,1168.44C2047.21,1165.99 2050.78,1164.68 2054.5,1164.81C2054.65,1164.81 2054.8,1164.81 2054.94,1164.82C2062.4,1165.07 2068.49,1170.92 2068.72,1178.07C2069.11,1190.32 2069.7,1208.42 2070.03,1218.78C2070.21,1224.11 2069.38,1229.39 2067.59,1234.39C2061.9,1250.28 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.504623,-0.816657,-0.850697,0.525657,4061,2244.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.42,1196.41 2040.03,1178.74C2039.87,1171.59 2045.95,1165.75 2053.74,1165.58C2053.74,1165.58 2053.74,1165.58 2053.74,1165.58C2057.64,1165.49 2061.45,1166.84 2064.32,1169.33C2067.19,1171.82 2068.89,1175.23 2069.03,1178.81C2069.78,1198.03 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2091.66,426.82 2082.52,416.658C2079.22,412.981 2078.99,407.432 2081.96,403.197C2082.74,402.084 2083.56,400.913 2084.39,399.737C2086.33,396.971 2089.39,395.15 2092.72,394.774C2096.04,394.398 2099.3,395.508 2101.57,397.798C2113.82,410.092 2133.82,430.189 2133.82,430.189L2180.66,505.744L2127.32,587.03C2127.32,587.03 2083.17,565.355 2078.82,559.124C2068.45,544.282 2043.18,508.696 2043.18,508.696Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788C2108.7,445.788 2091.66,426.82 2082.52,416.658C2079.22,412.981 2078.99,407.432 2081.96,403.197C2082.74,402.084 2083.56,400.913 2084.39,399.737C2086.33,396.971 2089.39,395.15 2092.72,394.774C2096.04,394.398 2099.3,395.508 2101.57,397.798C2113.82,410.092 2133.82,430.189 2133.82,430.189L2180.66,505.744L2127.32,587.03C2127.32,587.03 2083.17,565.355 2078.82,559.124C2068.45,544.282 2043.18,508.696 2043.18,508.696Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2080.52,406.081C2080.52,406.081 2113.49,442.598 2108.6,445.733L2066.22,422.191L2060.12,419.893C2060.12,419.893 2064.32,416.778 2065.61,415.829C2065.85,415.648 2066.1,415.475 2066.35,415.309C2068.65,413.813 2080.52,406.081 2080.52,406.081Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.310378,-0.950613,-0.950613,0.310378,3952.71,1900.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1866.57,1255.82L1890.77,1278.25L1963.63,1264.76L1888.79,1227.27L1866.57,1255.82Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12042,0,0,2.68095,-4066.71,-6096.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5109.6,2443.35L5109.6,2408.29L3682.98,2408.29L3682.98,2419.12L5109.6,2443.35Z",
    style: {
      fill: "rgb(229,230,232)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyChart);
export default __webpack_public_path__ + "static/media/guy_chart.7d7d3f29eafc3611d5ae1daff58d93b5.svg";
export { ForwardRef as ReactComponent };